import API from '@/services/api'

export default {
  getValue(key) {
    return API.get('/config/' + key)
  },
  postValue(key, value) {
    return API.post('/config', { key: key, value: value })
  }
}
